import React, { useState, useEffect,useContext } from "react";
import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import { FaPlus, FaSearch,FaPrint } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";
import getCurrentSkin from "../utils/getCurrentSkin";

const VehicleHsdFillingInsideReport = () => {
   const { isDark, skin, setSkin } = useContext(ThemeContext);
    const currentSkin =getCurrentSkin(skin)
      const { baseColor, baseShade } = currentSkin;
  const [branchType, setBranchType] = useState("HO");
  const [branchId, setBranchId] = useState(8);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [purchaseOrderNo, setPurchaseOrderNo] = useState("");
  const [projectCode, setProjectCode] = useState("");
  const [status, setStatus] = useState("");
  const [store, setStore] = useState("");
  const [supplier, setSupplier] = useState("");
  const [year,setYear]=useState("");
const [yearList, setYearList] =useState([]);
  const [branchList, setBranchList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [data, setData] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
  axios
    .get(`https://www.nissi-india.com/api/fillbranch_hsdRpt?branchid=8&branchtype=HO`)
         
    .then((res) => {
      setBranchList(res.data.branchList);
    })
    .catch((err) => {
      console.error("Dropdown fetch failed", err);
      toast.error("Failed to load dropdowns");
    });
}, [branchType, branchId]);
 useEffect(() => {
    axios
      .get("https://www.nissi-india.com/api/hsd_years")
     
      .then((res) => {
        setYearList(res.data || []);
      })
      .catch((err) => {
        console.error("Years fetch failed", err);
        toast.error("Failed to load years");
      });
  }, []);
 const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };
const handleSearch = () => {
   
  const params = {
    
  
    branch:branchId,
vehicleCode:projectCode,
vehicleName:"",
vehicleRegNo:"",
from:formatDate(fromDate)||"", 
to:formatDate(toDate)||"",
 month:"April"||"Select",
     year:"2022"||"Select",
    


   // Or set dynamically based on user context
  };
  
  console.log("Search payload", params);

  axios
    .get("https://www.nissi-india.com/api/hsd_fillingInside",{params})
    
    .then((res) => {
      console.log("Search api:", res.data);
      if (res.data.data && Array.isArray(res.data.data)) {
        setData(res.data.data);
      } else {
        setData([]);
        toast.warn("No purchase returns found");
      }
    })
    .catch((err) => {
      console.error("Purchase Return fetch failed", err);
      toast.error("Failed to fetch purchase return listing");
    });
};
const handlePrint = () => {
const params = {
    
     branch:branchId,
vehicleCode:projectCode,
vehicleName:"",
vehicleRegNo:"",
from:formatDate(fromDate)||"", 
to:formatDate(toDate)||"",
 month:"April"||"Select",
     year:"2022"||"Select",


   // Or set dynamically based on user context
  };
  // convert params to query string
  const query = new URLSearchParams(params).toString();

  // open report page in new tab/window
  window.open(`/inventory/Vehiclehsdfillinginside_AllPrint?${query}`, "_blank");
};

  return (
    <LayoutWrapper>
      <HeaderBar title="VEHICLE HSD FILLING HR/KM REPORT" />
      <ToastContainer />
      <div className={`p-6 mt-6 rounded-2xl shadow-xl border ${isDark ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-black" : `bg-white ${currentSkin.glass} text-black`}`}>
     
        <div className="grid grid-cols-2 gap-6 mb-4">

          {/* Branch Type */}
          <div className="col-span-1 flex items-center">
            <label className="mr-2">Own Vehicle</label>
            <input
              type="radio"
              name="branchtype"
              value="HO"
              checked={branchType === "HO"}
              onChange={() => setBranchType("HO")}
              className="mr-4"
            />
            <label className="mr-2">Hire Vehicle</label>
            <input
              type="radio"
              name="branchtype"
              value="Branch"
              checked={branchType === "Branch"}
              onChange={() => setBranchType("Branch")}
            />
          </div>
          </div>
           <div className="grid grid-cols-2 gap-6 mb-4">
        <div className="space y-4">

          {/* From Date */}
          <div className="col-span-1">
            <label>From Date</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="w-full border px-2 py-1"
            />
          </div>

          {/* To Date */}
          <div className="col-span-1">
            <label>To Date</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="w-full border px-2 py-1"
            />
          </div>

          {/* Purchase Order No */}
          <div className="col-span-1">
            <label>Vehicle Registration No</label>
            <input
              type="text"
              value={purchaseOrderNo}
              onChange={(e) => setPurchaseOrderNo(e.target.value)}
              className="w-full border px-2 py-1"
              placeholder="Enter PO No"
            />
          </div>

          {/* Project Code */}
          <div className="col-span-1">
            <label>Vehicle Code</label>
               <input
              type="text"
              value={projectCode}
              onChange={(e) => setProjectCode(e.target.value)}
              className="w-full border px-2 py-1"
            />
          </div>
            {/* Status */}
          <div className="col-span-1">
            <label>Vehicle Name</label>
            <select
              className="w-full border px-2 py-1"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">Select</option>
           
            </select>
          </div>
          </div>
          
        <div className="space y-4">

        

          {/* Supplier */}
          <div className="col-span-1">
            <label>Vehcile Main Type</label>
            <select
              className="w-full border px-2 py-1"
              value={supplier}
              onChange={(e) => setSupplier(e.target.value)}
            >
              <option value="">Select</option>
              {supplierList.map((s) => (
                <option key={s.fld_supplierid} value={s.fld_supplierid}>
                  {s.fld_suppliername}
                </option>
              ))}
            </select>
          </div>

          {/* Store */}
          <div className="col-span-1">
            <label>Branch</label>
            <select
              className="w-full border px-2 py-1"
              value={store}
              onChange={(e) => {
                setStore(e.target.value);
                setBranchId(parseInt(e.target.value));
              }}
            >
              <option value="">Select</option>
              {branchList.map((b) => (
                <option key={b.fld_storeid} value={b.fld_Branchid}>
                  {b.fld_BranchName}
                </option>
              ))}
            </select>
          </div>
            <div className="col-span-1">
            <label>Month</label>
            <select
              className="w-full border px-2 py-1"
              value={store}
              onChange={(e) => {
                setStore(e.target.value);
                setBranchId(parseInt(e.target.value));
              }}
            >
              <option value="">Select</option>
             
            </select>
          </div>
           <div className="col-span-1">
            <label>Year</label>
              <select
              className="w-full border px-2 py-1"
              value={year}
              onChange={(e) => {
                setYear(e.target.value);
             
              }}
            >
              <option value="">Select</option>
              {yearList.map((b) => (
                <option key={b.value} value={b.value}>
                  {b.text}
                </option>
              ))}
            </select>
          </div>
          </div>
          </div>
          {/* Search */}
          <div className="flex justify-center mt-4">
           <button
             onClick={handleSearch}
             className="flex items-center gap-2 bg-blue-600 text-white px-6 py-2 rounded"
           >
             <FaSearch /> Search
           </button>
                 <button
                                   onClick={handlePrint}
                                   className="flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-2 rounded-lg shadow transition"
                                 >
                                   <FaPrint /> Print
                                 </button>
         </div>
                 

        
        
        </div>

        {/* Grid */}
          <div className="mt-4">
        
             <table className="w-full text-xs">
            <thead>
              <tr className="bg-white print:bg-white">
                 <th className="border border-black px-1 py-2 text-center w-12 print:border-black">S.No</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Date</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Branch</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">HSD Filling Opening Hr</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">HSD Filling Closing Hr</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Working Hr</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">HSD Filling Opening KM</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">HSD Filling Closing KM</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Running KM</th>
                <th className="border border-black px-1 py-2 text-center w-16 print:border-black">HSD</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Diesel Consumption Hr</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Diesel Consumption KM</th>
                
              </tr>
            </thead>
           <tbody>
   {data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
      <td className="border border-black px-1 py-1 text-center">{index + 1}</td>
      <td className="border border-black px-1 py-1 text-center">{item.fld_Date}</td>

      {/* Vehicle Name clickable */}
      <td  className="border border-black px-1 py-1 text-center">
        {item.fld_BranchName}
      </td>

      <td className="border border-black px-1 py-1 text-center">{item.fld_hsdfillingopeninghr}</td>
      <td className="border border-black px-1 py-1 text-center">{item.fld_hsdfillingclosinghr}</td>
      <td className="border border-black px-1 py-1 text-center">{item.fld_Workinghr}</td>
      <td className="border border-black px-1 py-1 text-center">{item.fld_hsdfillingopeningkm}</td>
      <td className="border border-black px-1 py-1 text-center">{item.fld_hsdfillingclosingkm}</td>
      <td className="border border-black px-1 py-1 text-center">{item.fld_Workingkm}</td>
      <td className="border border-black px-1 py-1 text-center">{item.fld_Workingkm}</td>
      <td className="border border-black px-1 py-1 text-center">{item.fld_diselconsumptionhr}</td>
      <td className="border border-black px-1 py-1 text-center">{item.fld_diselconsumptionkm}</td>
   
    </tr>
    ))
  ) : (
    <tr>
      <td colSpan="13" className="text-center py-6 text-gray-500">
        No vehicle HSD records found for the specified criteria
      </td>
    </tr>
  )}</tbody>
          </table>
         
        </div>
    </LayoutWrapper>
  );
};

export default VehicleHsdFillingInsideReport;
